import { Pipe, PipeTransform, inject } from "@angular/core";
import { TvpiIrrFormatService } from "../services/tvpi-irr-format.service";
@Pipe({
    name: 'tvpiValueFormat'
})

export class TvpiValueFormatPipe implements PipeTransform {
    private tvpiFormat = inject(TvpiIrrFormatService);


    transform(value: number | string | null | undefined, negativeZeroValueWithParenthesis?: boolean): string | null {
        const numValue = typeof value === 'string' ? Number(value) : value;
        return this.tvpiFormat.getTvpiValue(numValue, negativeZeroValueWithParenthesis)
    }
}
